<custom-modal size="lg" [open]="open" [isShowHeader]="false" [isWithOverflow]="false" modalInnerBodyClass="p-0" (openChange)="onClose()">
  <app-document-preview-box
    [index]="index"
    [previewDocs]="previewDocs"
    [isShowDeleteButton]="isShowDeleteButton"
    [nonDeletableTypes]="nonDeletableTypes"
    [open]="open"
    (delete)="onDeleteDocument($event)"
    (close)="onClose()"
  ></app-document-preview-box>
</custom-modal>
